import React from "react";
import { Text as DefaultText, TextProps } from "react-native";
import { useThemeColor } from "../Themed";

export default function Text(props: TextProps) {
    const { style, ...otherProps } = props;
    const color = useThemeColor({}, 'text');
  
    return <DefaultText style={[{ color }, style]} {...otherProps} />;
  }